import { Dimension } from 'src/@enums'
import { BusinessUnitShortType } from 'src/@types'
import { gaEvent, getDimensionByUnit } from 'src/utils'

export type CustomerIdentification = BusinessUnitShortType & {
  customerId: string
}

/**
 * [TARGET]: Adiciona dimension para reconhecimento do usuário.
 *
 * [CONTEXTO]: Após a coleta de dados do consumidor, é retornado um ID único, utilizamos esse valor nessa dimension.
 *
 * [REGRAS]: A dimension por default será a ‘dimension22’, para businessUnit EUD a dimension será a ‘dimension20’.
 *
 */

export const customerIdentificationEvent = ({
  businessUnit,
  customerId,
}: CustomerIdentification) => {
  gaEvent({ [getDimensionByUnit(Dimension.CF_ID, businessUnit)]: customerId })
}
